
<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <ul class="breadcrumb">
      <li class="active"><a>Energymeter Configurator Mapping</a></li>
    </ul>
  </ul>
  <div class="right">
       
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">


  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="listing_outer acc_manager">
          <div class="filter_div">
            <div class="top">
              <h4>Energymeter Configurator Mapping</h4>
              <div class="right">
                &nbsp;
              </div>
            </div>
          </div>
        <!-- ***************** Device Modbus Mapping Content Start Here**************************-->
        <div *ngIf="isLoading" class="spinner-container">
          <div class="spinner"></div>
        </div>
                      
        <div [hidden]="isLoading">
          <!-- Addform Section -->
          <div *ngIf="formTitle === 'Addform'">
            <!-- File input for selecting XLSX file -->
            <input type="file" (change)="onFileChange($event)" style="width:223px;" />
        
            <!-- Wrapper div to enable scrolling -->
            <div style="overflow-y: auto; width: 1000px;">
              <div *ngIf="data.length > 0" class="em-config-tbl" style="margin-left:16px;margin-right:16px;">
        
                <!-- Header -->
                <div class="row header">
                  <div class="column" *ngFor="let header of headers">{{ header }}</div>
                  <div class="column">Columns</div>
                  <div class="column">Modbus Device No</div>                 
                  <div class="column">DeviceType ID</div>
                  <div class="column">ProductType</div>
                  <!-- <div class="column">
                    <input type="checkbox" id="myCheckbox" (change)="onChecked($event)" /> Select All
                  </div> -->
                </div>
        
                <!-- Rows -->
                <div *ngFor="let row of data; let i = index" class="row">
                  <div class="column" *ngFor="let header of headers">{{ row[header] }}</div>
                  
                  <div class="column">
                    <select [(ngModel)]="row.colName">
                      <option *ngFor="let column of columnOptions" [value]="column">{{ column }}</option>
                    </select>
                  </div>
        
                  <div class="column">
                    <select [(ngModel)]="row.modbusNumber">
                      <option *ngFor="let modbusNumber of deviceConnectionRange" [value]="modbusNumber">{{ modbusNumber }}</option>
                    </select>
                  </div>       
                 
        
                  <div class="column">
                    <input type="text" [(ngModel)]="row.deviceId" />
                  </div>
        
                  <div class="column">
                    <input type="text" [(ngModel)]="row.deviceCategoryId" />
                  </div>
        
                  <!-- <div class="column">
                    <input type="checkbox" [(ngModel)]="row.selected" />
                  </div> -->
                </div>
        
                <!-- Process Selected Button -->
                <div class="row">
                  <div class="column form_actions text-right">
                    <button (click)="OnSubmit()" class="primary_btn" style="border:none;">Process Selected</button>
                    <button class="default_btn" mat-raised-button (click)="cancelBtn()"><span>Cancel</span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <!-- Editform Section -->
          <div *ngIf="formTitle === 'Editform'">
            <div class="row header">
              <div class="column">Start</div>
              <div class="column">End</div>
              <div class="column">Description</div>
              <div class="column">Columns</div>
              <div class="column">Modbus Device No</div>
              <div class="column">Serial No</div>
              <div class="column">DeviceType ID</div>
              <div class="column">ProductType</div>
              <!-- <div class="column">
                CheckAll
                <input type="checkbox" id="myCheckbox" (change)="onChecked($event)" />
              </div> -->
            </div>
        
            <!-- Edit Rows -->
            <div *ngFor="let deviceModbus of editObj; let idx = index" class="row">


              <div class="column">
                <input type="hidden" [(ngModel)]="deviceModbus.id" />
                <input type="text" [(ngModel)]="deviceModbus.Start" />
              </div>
        
              <div class="column">
                <input type="text" [(ngModel)]="deviceModbus.End" />
              </div>

              <div class="column">
                <input type="text" [(ngModel)]="deviceModbus.Description" style="width:100px;" />
              </div>
        
              <div class="column">
                <select [(ngModel)]="deviceModbus.colName">
                  <option *ngFor="let column of columnOptions" [value]="column">{{ column }}</option>
                </select>
              </div>
        
              <div class="column">
                <select [(ngModel)]="deviceModbus.modbusNumber" style="width:162px;">
                  <option *ngFor="let modbusNumber of deviceConnectionRange" [value]="modbusNumber">{{ modbusNumber }}</option>
                </select>
              </div>
        
              <div class="column">
                <input type="text" [(ngModel)]="deviceModbus.serialNo" />
              </div>
        
              <div class="column">
                <input type="text" [(ngModel)]="deviceModbus.deviceId" [value]="devicetype_id" />
              </div>  
        
              <div class="column">
                <input type="text" [(ngModel)]="deviceModbus.deviceCategoryId" />
              </div>
        
              <!-- <div class="column">
                <input type="checkbox" [(ngModel)]="deviceModbus.selected" />
              </div> -->
        
              <div class="column">
                <button (click)="deleteRow(idx, deviceModbus.id)">Delete</button>
              </div>
            </div>
        
            <!-- Add New Row Button -->
            <div class="row">
              <div class="column">
                <button (click)="addRow()" class="primary_btn" style="border:none;">Add New</button>
              </div>
            </div>
        
            <!-- Process Selected Button -->
            <div class="row">
              <div class="column form_actions text-right">
                <button (click)="OnUpdate()" class="primary_btn" style="border:none;">Process Selected</button>
                <button class="default_btn" mat-raised-button (click)="cancelBtn()"><span>Cancel</span></button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- ***************** Device Modbus Mapping Content End Here**************************-->
         </div>
      </div>
    </div>
  </div>

  

</div>






